import { BuiltInComponents } from 'craft/constants';
import { SerializedNodeTree } from 'craft/types';

export const createFormStep = (stepId: string) =>
  (({
    rootNodeId: '3bBlLh',
    nodes: {
      '3bBlLh': {
        type: {
          resolvedName: BuiltInComponents.FormStep,
        },
        props: {
          stepId,
        },
        custom: {
          css: {
            paddingTop: '8px',
            paddingRight: '8px',
            paddingBottom: '8px',
            paddingLeft: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          },
        },
        name: 'FormStep',
      },
    },
  } as unknown) as SerializedNodeTree);
